import {Component, Input, OnInit} from '@angular/core';
import {BrowseComponent} from "@shared/components/browse/abstract.browse.component";
import {CommonsService} from "@core/service/commons.service";
import {Pagination} from "@core/bean/pagination";
import {Observable} from "rxjs/index";
import { HttpParams, HttpResponse } from '@angular/common/http';
import {BrowseConfig} from "@core/bean/browse-config";
import { AddressService } from '../../../../routes/jy-srm/basic-data/srm-address/address/address.service';
import { SettingsService } from '@delon/theme';
import { PageData } from '@core/bean/page-data';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tax-',
  templateUrl: './address.component.html',
  styles: []
})
export class AddressBrowseComponent implements BrowseComponent, OnInit {

  static componentName = 'AddressBrowseComponent';

  @Input() config:BrowseConfig;
  @Input() onOk:(data:any | [any]) => void;
  @Input() onCancel:() => void;

  //列表查询
  pagination: Pagination = new Pagination();
  visible = false;
  address: any = {};
  rough:string;
  fine:string;
  searchData:any = {};

  constructor(private commonsService: CommonsService,
              private service: AddressService,
              private settingService: SettingsService,
              private router: Router
  ) {
    this.pagination.getData = function(params: HttpParams): Observable<any> {
      return service.query(params);
    };
  }

  ngOnInit() {
    this.searchData = this.config.searchData;
    if (this.settingService.user.userType == '0') {
      this.rough = 'supplier';
      this.searchData['rough-eq'] = this.rough;
      this.service.getSupplierInfo().subscribe(data => {
        this.fine = this.rough + data.id;
        this.searchData['fine-eq'] = this.fine;
        this.pagination.searchData = this.searchData;
        this.getData();
      });
    } else {
      this.rough = 'purchaser';
      this.searchData['rough-eq'] = this.rough;
      this.pagination.searchData = this.searchData;
      this.getData();
    }
    if (!this.config.multiple) {
      this.pagination.multipleCheck = false;
    }

    this.visible = true;
  }

  modalOk() {
    let result = this.pagination.selectedRows;
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

  doubleGet(data){
    let result = [data];
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

  add(){
    this.router.navigate(['address',{ data:true}]);
    this.visible = false;
  }

  modalCancel() {
    this.visible = false;
    this.onCancel();
  }

  getData() {
    this.pagination.searchData = this.searchData;
    this.pagination.toFirstPage();
  }

  reset() {
    this.searchData = {};
    this.searchData['rough-eq'] = this.rough;
    this.searchData['fine-eq'] = this.fine;
  }
}
